import React from 'react';

import svg from './assets/index';
import { SvgProps } from './types';

const IconSVG = ({ name, url, ...rest }: SvgProps): JSX.Element | null => {
  const Component = svg[name];

  if (!Component) {
    return null;
  }

  return <Component url={url} {...rest} />;
};

export default IconSVG;
